<template>
  <div class="scheduled-post">
    <el-row>
      <el-col :span="colWidths[0]">
        <span>
          <strong>{{post.message}}</strong>
        </span>
      </el-col>
      <el-col :span="colWidths[1]">
        <span class="post-time">
          <i class="fa fa-clock-o">&nbsp;</i>
          <em>{{postTimestamp}}</em>
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="colWidths[0]">
        <el-tooltip v-if="containsMedia" content="Contains Media" placement="bottom">
          <span class="contains-media">
            <i class="fa fa-image"></i>
          </span>
        </el-tooltip>
        <span v-else class="pull-left">&nbsp;</span>
      </el-col>
      <el-col>
        <span class="post-controls">
          <el-tooltip content="Edit" placement="bottom">
            <i class="fa fa-pencil" @click="handleEditPost"></i>
          </el-tooltip>
          <el-tooltip content="Delete" placement="bottom">
            <i class="fa fa-trash" @click="handleDeletePost"></i>
          </el-tooltip>
        </span>
        <div v-if="channels.length">
          <el-tooltip v-for="channel in channelTypes" :key="channel">
            <div slot="content">
              <span
                class="social-icons"
                v-for="handle in getChannelHandlesByType(channel)"
                :key="handle"
              >
                {{handle}}
                <br>
              </span>
            </div>
            <social-icon v-if="channel" class="channel-icon" :type="channel"/>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint no-param-reassign: "off" */
import { Emoji } from 'emoji-mart-vue';
import Loader from '@/components/common/Loader';
import SocialIcon from '@/components/common/Icons/SocialIcon';
import moment from 'moment';

export default {
  name: 'ScheduledPost',

  data: () => ({
    colWidths: [12, 12],
    currentChannel: '',
  }),

  props: {
    post: {
      type: Object,
      required: true,
    },
    channels: {
      type: Array,
      default: [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    containsMedia() {
      return this.post.media.length > 0;
    },
    postTimestamp() {
      return moment(this.post.post_date).format('ddd, D MMMM YYYY HH:mm');
    },

    channelsFull() {
      return this.post.channels.map(x => this.channels.find(z => z.id === x));
    },

    channelTypes() {
      return Object.keys(
        this.channelsFull.reduce(
          (acc, x) => ({ ...acc, [this.getDefinedValue(x, 'channle_type')]: true }),
          {},
        ),
      );
    },
  },
  methods: {
    getChannelHandlesByType(type) {
      return this.channelsFull
        .filter(x => this.getDefinedValue(x, 'channle_type') === type)
        .map(x => this.getDefinedValue(x, 'handle'));
    },

    getDefinedValue(value, requestData) {
      const type = typeof value !== 'undefined';
      const request = {
        handle: type ? value.handle : 'Not assigned',
        channle_type: type ? value.channel_type_title : 'Default',
      };
      return request[requestData];
    },

    isDefined(value) {
      return typeof value !== 'undefined';
    },

    handleDeletePost() {
      this.$confirm('Are you sure you want to remove this scheduled post?').then(() => {
        this.$emit('delete', this.post.id);
      });
    },

    handleEditPost() {
      this.$emit('edit', this.post);
    },

    showScheduledPost() {
      return this.channelTypes.includes('Facebook');
    },
  },

  components: {
    SocialIcon,
    Emoji,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
$inner-border-color: rgba(0, 0, 0, 0.14);

.scheduled-post {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.14);
  padding: 8px;
  margin: 5px auto;

  .el-col {
    padding: 5px;
  }
}

.post-time {
  float: right;
}

.social-icons {
  float: right;
  border: 1px solid $inner-border-color;
  border-radius: 3px;
  padding: 3px;
}

.post-controls {
  border: 1px solid $inner-border-color;
  border-radius: 3px;
  padding: 3px;
  float: right;
  margin-left: 3px;

  .fa {
    cursor: pointer;
    margin: auto 3px;
  }
}

.channel-icon {
  display: inline;
  padding: 5px;
}

.contains-media {
  border: 1px solid $inner-border-color;
  border-radius: 3px;
  padding: 3px;
}
.reaction {
  padding: 10px;
  margin: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ScheduledPost.vue?0fa94bbf